import { IQuoteSection } from 'types/quote'
import PortSelect from 'components/common/PortSelect';
import { tradeTypeMenu, transportTypeMenu } from 'data/quote';
import AreaTitle from '../../AreaTitle';
import CreateArea from '../../CreateArea';
import { containerFileAtom, quoteFileAtom } from 'atom/quote';
import { useSetAtom } from 'jotai';
import { ReactComponent as XMark } from 'assets/common/xmark.svg'

const Second = ({ quoteInfo, setQuoteInfo }: IQuoteSection) => {
    const setFileArr = useSetAtom(quoteFileAtom)
    const setContainerFile = useSetAtom(containerFileAtom);

    return (
        <AreaTitle title='구간정보 입력' step='01' zIndex='z-40'>
            <div className='flex flex-col gap-6 px-10 py-6'>
                <CreateArea title='구분' isRequired>
                    <div className='flex items-center border-1 rounded w-[320px]'>
                        {
                            tradeTypeMenu.map((item, idx) => (
                                <div
                                    key={idx}
                                    className={`flex-1 py-3 rounded text-center border-1 transition-all cursor-pointer
                                ${quoteInfo?.step1?.tradeType === item.value ? 'text-primary border-primary' : 'text-[#ECEEF2] border-transparent'}`}
                                    onClick={() => {
                                        setQuoteInfo(p => ({
                                            ...p,
                                            step1: {
                                                ...p.step1,
                                                tradeType: item.value,
                                            }
                                        }))
                                    }}
                                >
                                    {item.label}
                                </div>
                            ))
                        }
                    </div>
                </CreateArea>

                <CreateArea title='운송' isRequired>
                    <div className='flex items-center border-1 rounded w-[320px]'>
                        {
                            transportTypeMenu.map((item, idx) => (
                                <div
                                    key={idx}
                                    className={`flex-1 flex items-center justify-center gap-1 py-3 rounded text-center border-1 transition-all cursor-pointer
                                ${quoteInfo?.step1?.transportType === item.value ? 'text-primary border-primary' : 'text-[#ECEEF2] border-transparent'}`}
                                    onClick={() => {
                                        setQuoteInfo(p => ({
                                            ...p,
                                            step1: {
                                                ...p.step1,
                                                transportType: item.value,
                                                originId: '',
                                                originCode: '',
                                                originAddress: '',
                                                destinationId: '',
                                                destinationCode: '',
                                                destinationAddress: '',
                                            },
                                            step2: {
                                                ...p.step2,
                                                shipmentMode: item.value === 'SEA' ? 'FCL-DRY' : '',
                                                containerList: [],
                                                packingList: []
                                            }
                                        }))
                                        setFileArr([])
                                        setContainerFile([])
                                    }}
                                >
                                    <item.icon fill={quoteInfo?.step1?.transportType === item.value ? '#196BFF' : '#ECEEF2'} />
                                    {item.label}
                                </div>
                            ))
                        }
                    </div>
                </CreateArea>

                <CreateArea title='출발지' isRequired isStart={quoteInfo?.step1?.transportType === 'SEA'}>
                    <div>
                        <div className='relative flex items-center gap-4'>
                            <PortSelect
                                height={40}
                                fontSize={14}
                                transportType={quoteInfo?.step1?.transportType}
                                transitAddress={quoteInfo?.step1?.originAddress}
                                className='flex-1 max-w-[320px] tablet:max-w-full'
                                value={quoteInfo?.step1?.originId}
                                placeholder={'출발지를 검색해주세요.'}
                                onChange={(allData) => {
                                    setQuoteInfo(p => ({
                                        ...p,
                                        step1: {
                                            ...p.step1,
                                            originId: allData.value,
                                            originCode: allData.label.split(' | ')[0],
                                            originAddress: allData.label.split(' | ')[1],
                                        }
                                    }))
                                }}
                            />
                            {
                                !!quoteInfo?.step1?.originId &&
                                <div
                                    className='right-11 absolute cursor-pointer'
                                    onClick={() => {
                                        setQuoteInfo(p => ({
                                            ...p,
                                            step1: {
                                                ...p.step1,
                                                originId: '',
                                                originCode: '',
                                                originAddress: '',
                                            }
                                        }))
                                    }}
                                >
                                    <XMark className='w-5' fill='#F00' />
                                </div>
                            }
                        </div>
                        {
                            quoteInfo?.step1?.transportType === 'SEA' &&
                            <p className='text-red text-sm'>* 한국 - 한국어, 한국 이외 - 영어로 검색해주세요.</p>
                        }
                    </div>
                </CreateArea>

                <CreateArea title='도착지' isRequired isStart={quoteInfo?.step1?.transportType === 'SEA'}>
                    <div>
                        <div className='relative flex items-center gap-4'>
                            <PortSelect
                                height={40}
                                fontSize={14}
                                transportType={quoteInfo?.step1?.transportType}
                                transitAddress={quoteInfo?.step1?.destinationAddress}
                                className='flex-1 max-w-[320px] tablet:max-w-full'
                                value={quoteInfo?.step1?.destinationId}
                                placeholder={'도착지를 검색해주세요'}
                                onChange={(allData) => {
                                    setQuoteInfo(p => ({
                                        ...p,
                                        step1: {
                                            ...p.step1,
                                            destinationId: allData.value,
                                            destinationCode: allData.label.split(' | ')[0],
                                            destinationAddress: allData.label.split(' | ')[1],
                                        }
                                    }))
                                }}
                            />
                            {
                                !!quoteInfo?.step1?.destinationId &&
                                <div
                                    className='right-11 absolute cursor-pointer'
                                    onClick={() => {
                                        setQuoteInfo(p => ({
                                            ...p,
                                            step1: {
                                                ...p.step1,
                                                destinationId: '',
                                                destinationCode: '',
                                                destinationAddress: '',
                                            }
                                        }))
                                    }}
                                >
                                    <XMark className='w-5' fill='#F00' />
                                </div>
                            }
                        </div>
                        {
                            quoteInfo?.step1?.transportType === 'SEA' &&
                            <p className='text-red text-sm'>* 한국 - 한국어, 한국 이외 - 영어로 검색해주세요.</p>
                        }
                    </div>
                </CreateArea>
            </div>
        </AreaTitle>
    )
}

export default Second